/**
 * Authentication Initialization Hook
 * 
 * Checks authentication status on app startup using cookies
 * Should be called once during app initialization
 */

import { useEffect } from 'react';
import { useAuthActions } from '@/store/authStore';

/**
 * Hook to initialize authentication status
 * 
 * Automatically checks if user is authenticated by attempting
 * to fetch current user data using existing cookies
 */
export const useAuthInit = () => {
  const { checkAuthStatus } = useAuthActions();

  useEffect(() => {
    // Check authentication status on app startup
    // This will use existing httpOnly cookies if available
    checkAuthStatus().catch(() => {
      // Ignore errors - user is simply not authenticated
      // The store will handle setting isAuthenticated to false
    });
  }, [checkAuthStatus]);
};

export default useAuthInit;